import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-purple-deep py-12 px-4 sm:px-6 lg:px-8" data-id="element-49">
        <div className="max-w-6xl mx-auto" data-id="element-50">
          <div className="flex flex-col items-center gap-6" data-id="element-51">
            <div className="text-center" data-id="element-52">
              <h3 className="text-lavender-light text-2xl font-bold font-heading mb-2" data-id="element-53">
                Plantillas Menopausia Sin Drama
              </h3>
              <p className="text-lavender/80 text-sm" data-id="element-54">
                Tu Calendario "Fases Lunares" para Mamás Latinas 40+
              </p>
            </div>

            <div className="flex gap-6 text-lavender-light text-sm" data-id="element-55">
              <button onClick={() => setOpenModal('privacy')} className="hover:text-white transition-colors duration-200 underline" data-id="element-56">
                Política de Privacidad
              </button>
              <span className="text-lavender/50" data-id="element-57">|</span>
              <button onClick={() => setOpenModal('terms')} className="hover:text-white transition-colors duration-200 underline" data-id="element-58">
                Términos y Condiciones
              </button>
            </div>

            <div className="text-lavender/60 text-sm text-center" data-id="element-59">
              <p data-id="element-60">
                © 2024 Plantillas Menopausia Sin Drama. Todos los derechos
                reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Modal */}
      <AnimatePresence data-id="element-61">
        {openModal === 'privacy' && <Modal onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-62">
            <div className="space-y-4 text-gray-700" data-id="element-63">
              <p data-id="element-64">
                En Plantillas Menopausia Sin Drama, respetamos tu privacidad y
                nos comprometemos a proteger tu información personal.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-65">
                Información que Recopilamos
              </h3>
              <p data-id="element-66">
                Cuando compras nuestras plantillas, recopilamos información
                básica necesaria para procesar tu pedido, incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-67">
                <li data-id="element-68">Nombre y dirección de correo electrónico</li>
                <li data-id="element-69">
                  Información de pago (procesada de forma segura por nuestro
                  proveedor de pagos)
                </li>
                <li data-id="element-70">Dirección IP y datos de navegación para prevenir fraude</li>
              </ul>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-71">
                Uso de tu Información
              </h3>
              <p data-id="element-72">Utilizamos tu información únicamente para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-73">
                <li data-id="element-74">Procesar y entregar tu compra</li>
                <li data-id="element-75">Enviarte actualizaciones sobre el producto (si las hay)</li>
                <li data-id="element-76">Mejorar nuestros productos y servicios</li>
                <li data-id="element-77">Cumplir con requisitos legales</li>
              </ul>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-78">
                Protección de Datos
              </h3>
              <p data-id="element-79">
                Implementamos medidas de seguridad para proteger tu información
                personal contra acceso no autorizado, alteración o divulgación.
                No vendemos ni compartimos tu información con terceros para
                fines de marketing.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-80">
                Tus Derechos
              </h3>
              <p data-id="element-81">Tienes derecho a:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-82">
                <li data-id="element-83">Acceder a tu información personal</li>
                <li data-id="element-84">Solicitar corrección de datos inexactos</li>
                <li data-id="element-85">Solicitar eliminación de tus datos</li>
                <li data-id="element-86">Retirar tu consentimiento en cualquier momento</li>
              </ul>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-87">
                Cookies
              </h3>
              <p data-id="element-88">
                Utilizamos cookies esenciales para el funcionamiento del sitio.
                No utilizamos cookies de seguimiento o publicidad de terceros.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-89">
                Contacto
              </h3>
              <p data-id="element-90">
                Si tienes preguntas sobre esta política de privacidad,
                contáctanos a través de nuestro correo electrónico de soporte.
              </p>

              <p className="text-sm text-gray-500 mt-6" data-id="element-91">
                Última actualización: Febrero 2024
              </p>
            </div>
          </Modal>}
      </AnimatePresence>

      {/* Terms Modal */}
      <AnimatePresence data-id="element-92">
        {openModal === 'terms' && <Modal onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-93">
            <div className="space-y-4 text-gray-700" data-id="element-94">
              <p data-id="element-95">
                Al comprar y usar las Plantillas Menopausia Sin Drama, aceptas
                los siguientes términos y condiciones:
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-96">
                1. Producto Digital
              </h3>
              <p data-id="element-97">
                Las Plantillas Menopausia Sin Drama son un producto digital que
                incluye 7 templates en formato PDF y editable (Canva/Google
                Docs), más materiales bonus. Recibirás acceso inmediato después
                de completar tu compra.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-98">
                2. Uso Permitido
              </h3>
              <p data-id="element-99">Tienes permiso para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-100">
                <li data-id="element-101">Usar las plantillas para tu uso personal</li>
                <li data-id="element-102">Imprimir las plantillas para tu uso personal</li>
                <li data-id="element-103">Compartir con tu familia inmediata (mismo hogar)</li>
                <li data-id="element-104">Editar y personalizar las plantillas para tu uso</li>
              </ul>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-105">
                3. Uso Prohibido
              </h3>
              <p data-id="element-106">NO tienes permiso para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-107">
                <li data-id="element-108">
                  Revender, redistribuir o compartir públicamente las plantillas
                </li>
                <li data-id="element-109">Reclamar las plantillas como tu propio trabajo</li>
                <li data-id="element-110">Usar las plantillas para fines comerciales</li>
                <li data-id="element-111">Compartir tu acceso de descarga con otras personas</li>
              </ul>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-112">
                4. Política de Reembolsos
              </h3>
              <p data-id="element-113">
                Debido a la naturaleza digital del producto y el acceso
                inmediato, no ofrecemos reembolsos después de la compra. Te
                recomendamos revisar toda la información del producto antes de
                comprar.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-114">
                5. Descargo de Responsabilidad Médica
              </h3>
              <p className="font-semibold" data-id="element-115">
                IMPORTANTE: Las plantillas son herramientas de seguimiento y
                organización, NO son consejo médico.
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-116">
                <li data-id="element-117">No reemplazan la consulta con un profesional de salud</li>
                <li data-id="element-118">No diagnostican ni tratan condiciones médicas</li>
                <li data-id="element-119">
                  Los remedios naturales mencionados son informativos; consulta
                  con tu médico antes de usarlos
                </li>
                <li data-id="element-120">
                  Si experimentas síntomas severos, busca atención médica
                  inmediata
                </li>
              </ul>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-121">
                6. Resultados No Garantizados
              </h3>
              <p data-id="element-122">
                Los testimonios y estadísticas compartidos son ejemplos reales,
                pero los resultados individuales pueden variar. Tu experiencia
                depende de tu consistencia, situación personal y otros factores
                de salud.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-123">
                7. Propiedad Intelectual
              </h3>
              <p data-id="element-124">
                Todas las plantillas, diseños, textos y materiales están
                protegidos por derechos de autor. Plantillas Menopausia Sin
                Drama retiene todos los derechos de propiedad intelectual.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-125">
                8. Actualizaciones
              </h3>
              <p data-id="element-126">
                Los compradores reciben acceso gratuito a actualizaciones
                futuras del producto. Te notificaremos por correo electrónico
                cuando haya nuevas versiones disponibles.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-127">
                9. Soporte Técnico
              </h3>
              <p data-id="element-128">
                Ofrecemos soporte técnico para problemas de descarga o acceso al
                producto. No ofrecemos soporte médico o de salud.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-129">
                10. Modificaciones
              </h3>
              <p data-id="element-130">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Los cambios entrarán en vigor inmediatamente
                después de su publicación.
              </p>

              <h3 className="text-xl font-bold text-purple-deep mt-6" data-id="element-131">
                11. Ley Aplicable
              </h3>
              <p data-id="element-132">
                Estos términos se rigen por las leyes de Estados Unidos.
                Cualquier disputa se resolverá en los tribunales
                correspondientes.
              </p>

              <p className="text-sm text-gray-500 mt-6" data-id="element-133">
                Última actualización: Febrero 2024
              </p>

              <p className="mt-6 p-4 bg-lavender-light/30 rounded-lg" data-id="element-134">
                Al completar tu compra, confirmas que has leído, entendido y
                aceptado estos Términos y Condiciones.
              </p>
            </div>
          </Modal>}
      </AnimatePresence>
    </>;
}
interface ModalProps {
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  onClose,
  title,
  children
}: ModalProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-135">
      <motion.div initial={{
      scale: 0.95,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} exit={{
      scale: 0.95,
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="bg-white rounded-3xl shadow-2xl max-w-3xl w-full max-h-[85vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-136">
        <div className="sticky top-0 bg-gradient-to-r from-purple-main to-lavender px-6 py-5 flex items-center justify-between border-b border-lavender/30" data-id="element-137">
          <h2 className="text-white text-2xl sm:text-3xl font-bold font-heading" data-id="element-138">
            {title}
          </h2>
          <button onClick={onClose} className="text-white hover:text-lavender-light transition-colors duration-200 p-2 rounded-full hover:bg-white/10" aria-label="Cerrar" data-id="element-139">
            <X className="w-6 h-6" data-id="element-140" />
          </button>
        </div>
        <div className="px-6 py-8 overflow-y-auto max-h-[calc(85vh-80px)]" data-id="element-141">
          {children}
        </div>
      </motion.div>
    </motion.div>;
}